import { Chip } from "@dust-tt/sparkle";

export function ExternalPill() {
  return <Chip size="mini" color="info" label="External" />;
}
